import { Outlet } from 'react-router-dom';

import styles from '@styles/modules/layouts/MainLayout.module.scss';

/**
 * Minimal full-height shell: routed pages scroll naturally with no global header/footer.
 */
const MainLayout = () => (
  <div className={styles.shell}>
    <main className={styles.main} role="main" tabIndex={-1}>
      <div className={styles.inner}>
        <Outlet />
      </div>
    </main>
  </div>
);

export default MainLayout;
